import React, { Component } from 'react';
import mapTheme from '../../../untils/map-theme.json'
import { getSessionStorage, setSessionStorage, getModelCategory } from '../../../untils/auth';
import { GoogleApiWrapper, Polyline, Marker, Map } from 'google-maps-react';


export class MapContainer extends Component {
  state = {
    zoom: 3, // 地图缩放
    initIcons: [{
      icon: {
        path: 'M 0,-1 0,1',
        strokeOpacity: 1,
        strokeWeight: 2,
        scale: 3
      },
      offset: '50%',
      repeat: '15px'
    }],
    routeData: [], //航线数据
    currentColor: '#0063DB', //机型颜色
    fromName: '', //出发地机场icao
    toName: '', //目的地机场icao
    infowindow: this.props.google ? new this.props.google.maps.InfoWindow() : '', //创建Google map信息框
    prevMarker: '', //记录上一个点击过的线段
  };
 
  mapRef = React.createRef();

  //动态添加信息框
  attachMessage = (marker, message, e) => {
    if (this.state.infowindow !== '') {
      this.state.infowindow.setContent(message)
      this.state.infowindow.setPosition(e.latLng);
      this.state.infowindow.open(this.props.google.maps, marker);
    }
  }

  //点击出发地&目的地
  onMarkerClick = (marker, e, item, type) => {
    let html = '';
    if (type === 'start') {
      html = `<h4 style="color:${item.Aircraft.ModuleColor}">From: ${item.startAirport.Icao}</h4>`;
    } else {
      html = `<h4 style="color:${item.Aircraft.ModuleColor}">To: ${item.endAirport.Icao}</h4>`;
    }
    this.setState({
      currentColor: item.Aircraft.ModuleColor
    });
    this.attachMessage(marker, html, e);
  }

  //点击地图航线，更改搜索框出发地&目的地
  changeSearchInput = (startAirport, endAirport) => {
    let flyLocationForm = getSessionStorage('flyLocationForm') ? JSON.parse(getSessionStorage('flyLocationForm')) : {};  
    let flyLocationTo = getSessionStorage('flyLocationTo') ? JSON.parse(getSessionStorage('flyLocationTo')) : {};

    if (startAirport) {
      this.saveAirportData(flyLocationForm, startAirport, 'from');
    }

    if (endAirport) {
      this.saveAirportData(flyLocationTo, endAirport, 'to');
    }
  }

  //点击线
  onPolylineClick = (marker, e, item, index) => {
    let { fromName, toName, prevMarker } = this.state;
    fromName = item.startAirport.Icao;
    toName = item.endAirport.Icao;

    //清除上一个点击的线（实线变虚线）
    if (prevMarker !== marker && prevMarker !== '') {
      prevMarker.setOptions({
        strokeOpacity: 0,
        initIcons: this.state.initIcons,
      })
    }

    //点击虚线展示出发地&目的地信息框
    let html = `<h4 style="color:${item.Aircraft.ModuleColor}">${item.startAirport.Icao}  →  ${item.endAirport.Icao}</h4>`;
    this.attachMessage(marker, html, e);
    
   
    //点击当前的线（虚线变实线）
    if (item.startAirport.Icao === fromName && item.endAirport.Icao === toName) {
      marker.setOptions({
        strokeOpacity: 1,
        initIcons: ''
      })
      this.setState({
        prevMarker: marker
      });
    } 

    this.setState({
      fromName,
      toName,
      currentColor: item.Aircraft.ModuleColor
    });

    this.changeSearchInput(item.startAirport, item.endAirport)
  }

  //存储数据到setSessionStorage
  saveAirportData = (flyLocation, airportData, type) => {
    flyLocation.airportName = airportData.Name;
    flyLocation.airportIcao = airportData.Icao;
    flyLocation.city = airportData.City;
    flyLocation.state = '';

    let additional = {
      airportIcao: airportData.Icao,
      city: airportData.City,
    }
    let obj = {
      additional: JSON.stringify(additional),
      id: airportData.Id,
      location: airportData.Location,
      name: airportData.Name
    }
    if (type === 'from') {
      setSessionStorage('flyLocationForm', JSON.stringify(flyLocation));
      setSessionStorage('from', JSON.stringify(obj));
      this.props.addressValue('from', obj);
    } else {
      setSessionStorage('flyLocationTo', JSON.stringify(flyLocation));
      setSessionStorage('to', JSON.stringify(obj));
      this.props.addressValue('to', obj);
    }
  }

  //更新航线数据
  updateRouteDataHandle = (emptyLegList) => {
    if (emptyLegList) {
      let routeData = emptyLegList;
      for (const item of routeData) {
        item.startAirport.location = {
          lat: Number(JSON.parse(item.startAirport.Location).lati),
          lng: Number(JSON.parse(item.startAirport.Location).long),
        }
        item.endAirport.location = {
          lat: Number(JSON.parse(item.endAirport.Location).lati),
          lng: Number(JSON.parse(item.endAirport.Location).long),
        }
        //判断机型
        getModelCategory(item.Aircraft.ModelCategory, item);
      }
      this.setState({
        routeData
      })
    }
  }
 
  componentDidMount () {
    if (this.props.emptyLegList) {
      this.updateRouteDataHandle(this.props.emptyLegList);
    }
    //如果父组件传来该方法 则调用方法将子组件this指针传过去
    if (this.props.onRef) {
      this.props.onRef(this);
    }

    if (this.props && this.props.google) {
      const styledMapType = new this.props.google.maps.StyledMapType(mapTheme);
      this.mapRef.current.map.mapTypes.set("Styled", styledMapType);
      this.mapRef.current.map.setMapTypeId("Styled");
    }
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    if (nextProps.emptyLegList) {
      this.updateRouteDataHandle(nextProps.emptyLegList);
    }
  }

  render() {
    let {
      initIcons,
      zoom,
      routeData,
      currentColor,
      fromName,
      toName,
    } = this.state;
    return (
      <div className="results-map-box">
        <style dangerouslySetInnerHTML={{
          __html: `.gm-style-iw-c {
            border: 1px solid ${currentColor};
          }
          .gm-style .gm-style-iw-t::after {
            border-left: 1px solid ${currentColor};
            border-bottom: 1px solid ${currentColor};
          }
          .gm-ui-hover-effect {
            display: none !important;
          }
          .gm-style-iw-d h4{
            margin-bottom:0;
            font-weight: 700;
            font-size: 12px;
            color: ${currentColor};
          }
          `
        }}></style>
        <Map
          google={this.props.google}
          zoom={zoom}
          ref={this.mapRef}
        >
         {/* 连线 */}
          {
            routeData && 
            routeData.map((item, index) => {
              return (
                <Polyline
                  key={index}
                  path={[item.startAirport.location,item.endAirport.location]}
                  geodesic={true}
                  strokeWeight={2}
                  strokeColor={item.Aircraft.ModuleColor}
                  options={{strokeOpacity: 0, icons: initIcons, }}
                  onClick={(props, marker, e) => { this.onPolylineClick(marker, e, item, index) }}
                />
              )
            })
          }
          {/* 起点坐标，需要循环 */}
          {
            routeData && 
            routeData.map((item, index) => {
              return (
                <Marker
                  key={index}
                  onClick={(props, marker, e) => { this.onMarkerClick(marker, e, item, 'start') }}
                  position={item.startAirport.location}
                  icon={
                    (item.startAirport.Icao === fromName && item.endAirport.Icao === toName)
                      ? require('../../../assets/imgs/svg/marker-active-icon.svg').default
                      : require('../../../assets/imgs/svg/marker-icon.svg').default
                  }
                  zIndex={
                    1000
                  }
                  name={'From: '+item.startAirport.Icao}
                >
                </Marker>
              )
            })
          }
          {/* 终点坐标，需要循环 */}
          {
            routeData && 
            routeData.map((item, index) => {
              return (
                <Marker
                  key={index}
                  onClick={(props, marker, e) => { this.onMarkerClick(marker, e, item, 'end') }}
                  position={item.endAirport.location}
                  icon={
                    (item.startAirport.Icao === fromName && item.endAirport.Icao === toName)
                      ? require('../../../assets/imgs/svg/marker-active-icon.svg').default
                      : require('../../../assets/imgs/svg/marker-icon.svg').default
                  }
                  zIndex={
                    1000
                  }
                  name={'To: '+item.endAirport.Icao}
                >
                </Marker>
              )
            })
          }
        </Map>
      </div>
    );
  }
}

export default GoogleApiWrapper({
  // apiKey: 'AIzaSyC-7T30hUI0_Avoak71RNN1mgUbeY0nX5o',
  apiKey: 'AIzaSyAtMvOFQlg7_XA4-OuVcjqXBUys7kdhyPs',
})(MapContainer);
